import deepMerge from 'deepmerge';
import React from 'react';
import { ThemeProvider as AscThemeProvider } from 'styled-components';
import { ascDefaultTheme } from '.';
const ThemeProvider = ({ theme: defaultTheme = ascDefaultTheme, overrides, deep = true, children, }) => {
    const theme = deep
        ? deepMerge(defaultTheme, overrides || {})
        : Object.assign(Object.assign({}, defaultTheme), overrides);
    return (React.createElement(AscThemeProvider, { theme: theme },
        React.createElement(React.Fragment, null, children)));
};
export default ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map